import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { RegistrationService } from '@viewbid/ts-angular-client';
import { HttpErrorResponse } from '@angular/common/http';
import { VbSnackbarService } from '@viewbid/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vb-verify-phone-number',
    templateUrl: './verify-phone-number.component.html',
    styleUrls: ['./verify-phone-number.component.scss'],
})
export class VerifyPhoneNumberComponent implements OnChanges {
    optCode: string = '';
    errorText: string = '';
    isPhoneVerified: boolean = false;
    isOTPSent: boolean = false;
    isLoading: boolean = false;
    @Output() isPhoneNumberVerified: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() skipVerification: EventEmitter<void> = new EventEmitter<void>();
    @Input() isFromProfile: boolean = false;

    constructor(
        private registrationService: RegistrationService,
        private snackbarService: VbSnackbarService,
        private translate: TranslateService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes['sendOTPDirectly'] &&
            changes['sendOTPDirectly'].currentValue
        ) {
            this.sendOTP();
        }
    }

    async sendOTP(isResend: boolean = false): Promise<void> {
        this.isLoading = true;
        await this.registrationService.sendVerificationCode().subscribe({
            next: () => {
                if (!isResend) {
                    this.isOTPSent = true;
                }
                this.isLoading = false;
            },
            error: (err: HttpErrorResponse) => {
                this.isLoading = false;
                if (err.error.statusCode && err.error.statusCode === 429) {
                    this.snackbarService.error(
                        this.translate.instant('Users.sendOTPLimitExceeded'),
                    );
                    return;
                }
                this.snackbarService.error(err.error.message);
            },
        });
    }

    onOTPInput(event: Event): void {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        input.value = input.value.replace(/\D/g, '');
    }

    async verifyOTP(): Promise<void> {
        this.isLoading = true;
        this.registrationService
            .verifyPhoneNumber({ code: this.optCode })
            .subscribe({
                next: async () => {
                    this.isOTPSent = false;
                    this.isPhoneVerified = true;
                    await new Promise((resolve: any) =>
                        setTimeout(resolve, 2000),
                    );
                    this.isPhoneNumberVerified.emit(this.isPhoneVerified);
                },
                error: (err: HttpErrorResponse) => {
                    this.isLoading = false;
                    if (err.error.statusCode && err.error.statusCode === 429) {
                        this.snackbarService.error(
                            this.translate.instant(
                                'Users.verifyOTPLimitExceeded',
                            ),
                        );
                        return;
                    }
                    this.errorText = err.error.message;
                },
            });
    }

    onInputChange(event: Event): void {
        const input: HTMLInputElement = event.target as HTMLInputElement;
        // Remove any non-numeric characters
        input.value = input.value.replace(/\D/g, '');
    }

    skipTelephoneVerification(): void {
        this.skipVerification.emit();
    }

    closeVerification(): void {
        this.isOTPSent = false;
        this.isPhoneVerified = false;
        this.isPhoneNumberVerified.emit(this.isPhoneVerified);
    }
}
